angular.module('impactx.smartform').directive('ixSmartFormComponent', function ($compile) {
    return {
        restrict: 'EA',
        require: ['?^form'],
        scope: {
            smartFormIdentifier: "=",
            component: "=",
        },
        controller: 'SmartFormComponentCtrl',
        controllerAs: 'smartFormComponentCtrl',
        link: function (scope, element, attrs, formCtrl) {
            scope.formCtrl = formCtrl[0];

            scope.$watch('component', function (component) {
                if (component && component.template) {
                    element.html(component.template);
                    $compile(element.contents())(scope);
                }
            });
        }
    }
});